<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { api } from '@/api';

const router = useRouter();
const token = ref('');
const error = ref('');
const loading = ref(false);

async function login() {
  if (!token.value.trim()) {
    error.value = 'Veuillez entrer un jeton';
    return;
  }

  loading.value = true;
  error.value = '';

  try {
    // Validate token by calling health endpoint
    localStorage.setItem('auth_token', token.value);
    await api.getHealth();
    router.push('/');
  } catch (e) {
    localStorage.removeItem('auth_token');
    error.value = 'Jeton invalide';
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100">
    <div class="max-w-md w-full space-y-8 px-4">
      <div class="flex flex-col items-center">
        <img src="/logo-klever.svg" alt="Klever" class="h-16 w-auto mb-6" />
        <h2 class="text-center text-2xl font-bold text-gray-900">
          Tableau de bord Webhook
        </h2>
        <p class="mt-2 text-center text-sm text-gray-600">
          Entrez votre jeton d'accès pour continuer
        </p>
      </div>
      <form class="mt-8 space-y-6" @submit.prevent="login">
        <div>
          <label for="token" class="sr-only">Jeton d'accès</label>
          <input
            id="token"
            v-model="token"
            type="password"
            required
            class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            placeholder="Jeton d'accès"
          />
        </div>

        <div v-if="error" class="text-red-600 text-sm text-center">
          {{ error }}
        </div>

        <div>
          <button
            type="submit"
            :disabled="loading"
            class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-[#0076b8] hover:bg-[#005a8c] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0076b8] disabled:opacity-50"
          >
            {{ loading ? 'Validation...' : 'Se connecter' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
